<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <h5 class="flex items-center"><i class="dot"></i>⑨ 일일TBM 활동 현황</h5>
      <div class="flex-1">
        <div class="inline-block flex items-center cursor-pointer" @click="showPopup = true">
          <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />
          <span style="color: #7e72f2"> TBM순서 </span>
        </div>
      </div>
      <div v-if="!readonly && !isPrint">
        <vs-button color="secondary" type="border" @click="handleAddRow"> 항목추가 </vs-button>
        <vs-button class="ml-4" color="secondary" @click="handleRemoveRow"> 선택삭제 </vs-button>
      </div>
    </div>

    <table>
      <colgroup>
        <col v-if="!readonly" width="36" />
      </colgroup>
      <thead>
      <tr>
        <th v-if="!readonly">
          <vs-checkbox :value="checkData.length === list.length && 0 < list.length" class="justify-center mx-0" @click.native="onClickAllCheck" />
        </th>
        <th>구분</th>
        <th>전일누계</th>
        <th>금일</th>
        <th>누계</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in list" :key="item.id">
          <td v-if="!readonly"><vs-checkbox v-model="checkData" :vs-value="item.id" /></td>
          <td>
            <ml-input v-if="readonly" v-model="data" style="background-color: #fafafa" readonly class="w-full flex-" />
            <vs-select v-else :readonly="readonly" autocomplete :value="item.input1" @input="(data) => inputInput1(item_i, data)" class="w-full">
              <vs-select-item v-for="option in optionFilter" :key="option.type" :text="option.type" :value="option.type" />
              <vs-select-item v-if="item.input1 !== '기타'" :text="item.input1" :value="item.input1" />
              <vs-select-item text="기타" value="기타" />
            </vs-select>
            <ml-input v-if="item.input1 === '기타'" :readonly="readonly" v-model="item.input1_1" class="w-full mt-2" />
          </td>
          <td><comma-input readonly v-model="item.input2" class="w-full" placeholder="자동(전일까지누계 합산)" /></td>
          <td><comma-input :readonly="readonly" v-model="item.input3" class="w-full" placeholder="숫자입력" /></td>
          <td><comma-input readonly :value="item.input4" class="w-full" placeholder="자동(전일누계 + 금일)" /></td>
        </tr>
      </tbody>
    </table>

    <vs-popup title="TBM순서" :active.sync="showPopup">
      <table>
        <colgroup>
          <col width="70" />
        </colgroup>
        <thead>
          <th>순서</th>
          <th colspan="2">내용</th>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center">1</td>
            <td style="text-align: center">집합·인사</td>
            <td>직원, TBM리더, 팀원</td>
          </tr>
          <tr>
            <td style="text-align: center">2</td>
            <td style="text-align: center">보호구확인</td>
            <td>리더→팀원, 팀원간</td>
          </tr>
          <tr>
            <td style="text-align: center">3</td>
            <td style="text-align: center">당일작업 및 위험사항 전달</td>
            <td>전원참여. 위험예지</td>
          </tr>
          <tr>
            <td style="text-align: center">4</td>
            <td style="text-align: center">기타사항 전파</td>
            <td>전파원청사 직원, 리더</td>
          </tr>
          <tr>
            <td style="text-align: center">5</td>
            <td style="text-align: center">지적확인</td>
            <td>모든팀원 3회 복창</td>
          </tr>
        </tbody>
      </table></vs-popup
    >
  </div>
</template>

<script>
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    DisasterClassSelector,
    DateSelector,
  },
  props: {
    readonly: { type: Boolean, default: false },
    isPrint: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    selectOption: { type: Array, default: () => [] },
  },
  data() {
    return {
      showPopup: false,
      checkData: [],
      list: this.value,
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
    };
  },
  computed: {
    // 사용한 option은 제외시킨다
    optionFilter() {
      const useType = this.value
        .map((_v) => {
          return _v.input1;
        })
        .filter((v) => v !== "기타");
      return this.selectOption.filter((option) => !useType.includes(option.type));
    },
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        value.map((data) => {
          data.input4 = Number(data.input2 || 0) + Number(data.input3 || 0);
        });
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // All 체크박스 클릭
    onClickAllCheck() {
      if (this.checkData.length === this.list.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    // 항목추가
    handleAddRow() {
      const addData = { id: ++this.numberId, input1: "기타" };
      this.list.push(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },
    inputInput1(index, data) {
      const prevData = this.selectOption.find((item) => item.type === data);
      const prevValue = prevData ? prevData.value : "";

      this.$set(this.list, index, { input1: data, input1_1: data === "기타" ? "" : data, input2: prevValue, input3: "" });
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 5px;

    &::v-deep .con-vs-checkbox {
      justify-content: center !important;
      margin: 0;
      span {
        margin: 0;
      }
    }
    &::v-deep .con-vs-radio {
      width: 100%;
      justify-content: center !important;
    }
  }
  th {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;

    background: #f9f9f9;
    padding: 21px 7px;
  }
}

.disaster::v-deep {
  .con-select {
    width: 100%;
  }
}
</style>
